import React from 'react'
import PropTypes from 'prop-types'

import S from './ToTop.styled'
import { CsChevronUp } from '../../Svg'
import { TabNavigation } from '../../TabNavigation'
import languages from '../../../../languages'

const ToTop = ({ toTopText = '', lang = 'en' }) => {
  const scrollToTop = () =>
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })

  const intlFooter = languages[lang]
    ? languages[lang].footer
    : languages.en.footer
  const { back_to_top: intlToTop } = intlFooter
  const text = toTopText || intlToTop

  return (
    <S.ToTop>
      <TabNavigation
        onClick={scrollToTop}
        onEnterPress={scrollToTop}
        className="to-top"
      >
        {text} <CsChevronUp className="icon-chevron" />
      </TabNavigation>
    </S.ToTop>
  )
}

ToTop.propTypes = {
  toTopText: PropTypes.string,
  lang: PropTypes.string,
}

export default ToTop
